'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var Row = require('./Row.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["width", "w", "className"];
/**
 * Col
 *
 * A copy of the `Col` element of common CSS frameworks. Accepts fractions as width's.
 */
var Col = react.forwardRef(function (props, ref) {
  var widthProp = props.width,
    wProp = props.w,
    className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useRowContext = Row.useRowContext(),
    spacing = _useRowContext.spacing,
    width = _useRowContext.width;
  var styles = {
    position: 'relative',
    width: '100%',
    pl: spacing,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: utils.mapResponsive(widthProp || wProp || width, function (r) {
      return r > 1 || typeof r === 'string' ? r : "".concat(r * 100, "%");
    }),
    maxWidth: utils.mapResponsive(widthProp || wProp || width, function (r) {
      return r > 1 || typeof r === 'string' ? r : "".concat(r * 100, "%");
    })
  };
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx("chakra-col", className),
    __css: styles
  }, rest, {
    ref: ref
  }));
});
Col.displayName = 'Col';
exports.Col = Col;